export const SITE_URL = "https://www.cybermon.co.in";
export const SITE_NAME = "Cybermon";
export const DEFAULT_TITLE = "Cybermon | AI-Driven Cyber Risk Intelligence Platform";
export const DEFAULT_DESCRIPTION =
  "Cybermon unifies Attack Surface Intelligence, Digital Risk Intelligence, and Compliance & Cloud Security into one AI-driven cyber risk intelligence platform. See risk before attackers exploit it.";
export const LEADS_EMAIL = "leads@cybermon.co.in";
export const CONTACT_PHONE = "+91 94836 47986";
export const CONTACT_PHONE_TEL = "+919483647986";
export const LEADS_ENDPOINT = `https://formsubmit.co/ajax/${LEADS_EMAIL}`;

export function absoluteUrl(path = "/") {
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
